import { AESDecryptAny } from '../../encrypt-util';

/**
 * Builds session params previously supplied via cookies (login + /view/params).
 * Sent as `values` on each view query for set_config.
 * Bigint settings (liner_id, partner_id) are sent as numbers so they never become "".
 */
export function buildViewSessionValues(state: any): Record<string, string | number> {
  const locale = new Intl.DateTimeFormat().resolvedOptions().locale;
  const timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;

  let date = new Date('2024-12-31').toLocaleDateString();
  date = date
    .replaceAll('31', 'dd')
    .replaceAll('12', 'MM')
    .replaceAll('2024', 'yyyy');

  let dateTime = new Date('2024-12-31 23:59:58').toLocaleString();
  dateTime = dateTime
    .replaceAll('31', 'dd')
    .replaceAll('12', 'MM')
    .replaceAll('2024', 'yyyy')
    .replaceAll('23', 'HH24')
    .replaceAll('59', 'MI')
    .replaceAll('58', 'SS')
    .replaceAll('11', 'HH');

  const profile = state?.userProfile?.profile;
  const values: Record<string, string | number> = {
    locale,
    date_format: date,
    time_format: dateTime,
    time_zone: timeZone,
  };

  const linerId = toBigintValue(
    state?.navbarTop?.linerId ||
      AESDecryptAny(window.localStorage.getItem('liner_id'))
  );
  if (linerId != null) {
    values.liner_id = linerId;
  }

  const partnerId = toBigintValue(profile?.partnerId);
  if (partnerId != null) {
    values.partner_id = partnerId;
  }

  if (profile?.partnerType) {
    values.partner_type = String(profile.partnerType);
  }

  if (profile?.email) {
    values.user_mail = String(profile.email);
  }

  const partnerCountry =
    state?.userProfile?.linerDataCountry || profile?.partnerCountry;
  if (partnerCountry) {
    values.partner_country = String(partnerCountry);
  }

  const language = state?.navbarTop?.language;
  if (language) {
    values.language = String(language);
  }

  return values;
}

/** Returns a finite number for bigint session vars, or null if missing/blank/invalid. */
function toBigintValue(raw: unknown): number | null {
  if (raw == null || raw === '') {
    return null;
  }
  const n = typeof raw === 'number' ? raw : Number(String(raw).trim());
  if (!Number.isFinite(n)) {
    return null;
  }
  return n;
}
